import type { PolicyState } from './Policy.types';
import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';
import { useStateUpdate } from '@/shared/lib/pinia/useStateUpdate';
import { PolicyStatus } from './Policy.types';

const storeKey = 'PolicyStore';

function defaultState(): PolicyState {
  return {
    policyId: '',
    newPolicyInfo: null,
    startDate: null,
    endDate: null,
    status: null,
    transId: '',
    upgradeInstalmentPayment: false,
    activePolicyState: null,
    isContinueBuying: false,
    noInstallmentForPolicy: false,
    isInstallment: false,
    isDowngraded: false,
  };
}

export const usePolicyStore = defineStore(
  storeKey,
  () => {
    const state = reactive<PolicyState>(defaultState());
    const $update = useStateUpdate<PolicyState>(state);

    const noInstallmentForPolicy = computed(
      () =>
        !state.isInstallment
        || state.status === PolicyStatus.NON_RENEWABLE
        || state.status === PolicyStatus.RENEWABLE,
    );

    const reset = () => {
      Object.assign(state, defaultState());
    };

    return {
      state,
      $update,
      noInstallmentForPolicy,
      reset,
    };
  },
  { persist: { key: storeKey } },
);
